import { Button } from "@mui/material"

const joinClasses = (...classes) => classes.filter(Boolean).join(" ")

const muiVariantBySemantic = {
    primary: "contained",
    secondary: "outlined",
    header: "contained",
    link: "text",
}

const variantClasses = {
    primary: "landing-button--primary",
    secondary: "landing-button--secondary",
    header: "landing-button--header",
    link: "landing-button--link",
}

const sizeClasses = {
    header: "landing-button--header-size",
    heroPrimary: "landing-button--hero-primary-size",
    heroSecondary: "landing-button--hero-secondary-size",
    section: "landing-button--section-size",
    link: "landing-button--link-size",
}

const LandingButton = ({
    variant = "primary",
    size = "heroPrimary",
    className = "",
    children,
    ...props
}) => (
    <Button
        className={joinClasses(
            "landing-button",
            variantClasses[variant],
            sizeClasses[size],
            className,
        )}
        disableElevation
        disableRipple
        variant={muiVariantBySemantic[variant]}
        {...props}
    >
        {children}
    </Button>
)

export default LandingButton